import { useMemo } from 'react';

import { getFormAppDefinition } from '@/features/Dashboard/apps';
import type { FormAppType } from '@/features/Dashboard/apps';
import { Preview } from '@/features/Dashboard/components/Preview';
import { useAppForm } from '@/features/Dashboard/form/AppForm/context';
import type { AppFormValues } from '@/features/Dashboard/form/AppForm/context/types';

const FormPreviewContent = ({
  values,
  enabled
}: {
  values: AppFormValues | null;
  enabled: boolean;
}) => {
  const template = useMemo(() => {
    if (!values?.type) return undefined;
    return getFormAppDefinition(values.type as FormAppType).toWidget(values);
  }, [values]);
  return (
    <Preview
      enabled={enabled}
      template={template}
    />
  );
};

export const FormPreview = () => {
  const { form, canPreview } = useAppForm();
  return (
    <form.Subscribe selector={s => ({ values: s.values })}>
      {({ values }) => (
        <FormPreviewContent
          enabled={canPreview && !!values?.symbols?.active.length}
          values={values}
        />
      )}
    </form.Subscribe>
  );
};
